import { render } from "./ItemExistsModal.vue?vue&type=template&id=36725cc8&scoped=true"
import script from "./ItemExistsModal.vue?vue&type=script&lang=js"
export * from "./ItemExistsModal.vue?vue&type=script&lang=js"

import "./ItemExistsModal.vue?vue&type=style&index=0&id=36725cc8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36725cc8"]])

export default __exports__